import { sumCharCodeHash } from "./sum-char-code-hash";

// Reordered from NOTE_CARD_PALETTE to maximise hue distance between consecutive
// slots — alternates warm/cool so the first 10 simultaneous users look distinct.
// Sequence: red → teal → amber → steel blue → lavender → yellow → dark purple
//           → coral → sky blue → olive
export const PRESENCE_COLOR_PALETTE = [
	"#CF4E44", // red       (warm)
	"#248B8E", // teal      (cool)
	"#D4AA37", // amber     (warm)
	"#517599", // steel blue (cool)
	"#A77FBC", // lavender  (cool-warm)
	"#D7CB3E", // yellow    (warm)
	"#5E5482", // dark purple (cool)
	"#E77B6C", // coral     (warm)
	"#8DB6C6", // sky blue  (cool)
	"#90AA65", // olive     (warm-cool)
] as const;

/** Deterministic color from userId hash — stable across all boards. */
export function getPresenceColorForUser(userId: string): string {
	const hash = sumCharCodeHash(userId);
	return PRESENCE_COLOR_PALETTE[hash % PRESENCE_COLOR_PALETTE.length];
}
